// extracted by mini-css-extract-plugin
module.exports = {"oAuthIntegrations":"OauthIntegrations_oAuthIntegrations__1RNi4","content":"OauthIntegrations_content__14V_k"};